module.exports = __webpack_public_path__ + "favicon-196x196.png?0efd0c6d131edd565eee43cc12007420";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon-196x196.png
// module id = 187
// module chunks = 0